var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',{class:_vm.$style.layout,attrs:{"is-light":false}},[_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }